import CPoker from './CPoker';

class CPokerOmaha extends CPoker {
    constructor(props) {
        super(props);
    }
}

export default CPokerOmaha;
